import { smartAxios } from "../axios/Axios";
import { notificationEndpoints } from "../notification/notificationEndpoints";

export const getNotificationList = () => {
    return smartAxios.get(notificationEndpoints.getNotificationList)
}

export const postNotificationViewed = (id: number) => {
    return smartAxios.post(notificationEndpoints.postNotificationViewed, {
        id: id
    });
};